function view (path) {
  return () => import(/* webpackChunkName: 'accountant-v2' */ '@/views/accountant/' + path + '.vue').then(m => m.default || m) // eslint-disable-line prefer-template
}

const RAccountant = [
  {
    path: '/accountant/dashboard',
    component: view('Dashboard'),
    name: 'accountant.dashboard'
  },
  {
    path: '/accountant/tracking/customer-memos',
    component: view('customer-memos/Base'),
    name: 'accountant.tracking.customer-memos'
  }
]

const RAccountantReports = [
]

export default RAccountant.concat(
  RAccountantReports
)
